import { render, staticRenderFns } from "./c_crop_navigation.vue?vue&type=template&id=2b29c251"
import script from "./c_crop_navigation.vue?vue&type=script&lang=js"
export * from "./c_crop_navigation.vue?vue&type=script&lang=js"
import style0 from "./c_crop_navigation.vue?vue&type=style&index=0&id=2b29c251&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports